/**
 * Given an array of active filters, a filter type, a filter value, and a new
 * filter value, updates the old filter value with the new one. Returns a copy
 * of the active filters array with the change applied.
 * @param {Array} activeFilters - An array of active filter objects.
 * @param {string} type - The type of filter to modify.
 * @param {string|number} value - The value of the filter to modify.
 * @param {string|number} next - The new value to apply.
 * @returns {Array} The modified active filters array.
 */
const updateActiveFilter = (activeFilters, type, value, next) => activeFilters
  .map((filter) => (
    type === filter.type && value === filter.value
      ? { ...filter, value: next }
      : filter
  ));

export default updateActiveFilter;
